import { Link } from 'react-router-dom';
import { getPopularComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function FeaturedComics() {
  const popularComics = getPopularComics(8);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            热门推荐
          </h2>
          <Link
            to="/category/love"
            className="text-sm text-primary-600 hover:text-primary-700 transition-colors flex items-center gap-1 whitespace-nowrap"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4 md:gap-5">
          {popularComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}